export const openApkDownload = (downloadUrl) => {
  if (!downloadUrl) return
  window.open(downloadUrl, '_blank', 'noopener,noreferrer')
}

export const copyDownloadUrl = async (downloadUrl) => {
  if (!downloadUrl) return
  await navigator.clipboard.writeText(downloadUrl)
}
